import { useState } from 'react';

export default function WhyUs() {
  const [flippedCards, setFlippedCards] = useState<number[]>([]);

  const cards = [
    {
      title: "Revolutionary Technology",
      description: "Higher efficiency benchmark against conventional methods. Our technology targets low operational costs, low maintenance requirements, long durability."
    },
    {
      title: "Environmental Protection",
      description: "Our technology utilizes pure water without any additives."
    },
    {
      title: "All in 1 Approach",
      description: "Unique IP, a world-class team of scientists, consultants, and industry experts. We make sure to provide comprehensive offering to meet the individual needs of our partners."
    },
    {
      title: "Long-Term Partnerships",
      description: "Focusing on common goals, mutual respect, and joint innovation. We collaborate with partners and engage in projects that are built on mutual prosperity."
    }
  ];

  const handleCardHover = (index: number, isHovering: boolean) => {
    if (isHovering) {
      setFlippedCards(prev => [...prev, index]);
    } else {
      setFlippedCards(prev => prev.filter(i => i !== index));
    }
  };

  return (
    <section 
      id="why-us" 
      className="relative py-32"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/740469727c0a2473327c621f80af2ccf.jpeg)',
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20">
          <p className="text-sm uppercase tracking-wider text-gray-500 mb-6 font-light">Competitive Advantages</p>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight max-w-4xl">
            Why Hydville
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card, index) => (
            <div
              key={index}
              className="relative h-80 cursor-pointer"
              style={{ perspective: '1000px' }}
              onMouseEnter={() => handleCardHover(index, true)}
              onMouseLeave={() => handleCardHover(index, false)}
            >
              <div
                className="relative w-full h-full transition-transform duration-700"
                style={{
                  transformStyle: 'preserve-3d',
                  transform: flippedCards.includes(index) ? 'rotateY(180deg)' : 'rotateY(0deg)'
                }}
              >
                {/* Front Side */}
                <div
                  className="absolute inset-0 rounded-2xl flex items-center justify-center p-8"
                  style={{ 
                    backgroundColor: '#d6dee4',
                    backfaceVisibility: 'hidden',
                    WebkitBackfaceVisibility: 'hidden',
                    zIndex: flippedCards.includes(index) ? 1 : 2,
                    transform: 'rotateY(0deg)'
                  }}
                >
                  <h3 className="text-3xl lg:text-4xl font-bold text-center" style={{ color: '#0d6194' }}>
                    {card.title}
                  </h3>
                </div>

                {/* Back Side */}
                <div
                  className="absolute inset-0 rounded-2xl flex items-center justify-center p-8"
                  style={{
                    backgroundColor: '#d6dee4',
                    backfaceVisibility: 'hidden',
                    WebkitBackfaceVisibility: 'hidden',
                    transform: 'rotateY(180deg)',
                    zIndex: flippedCards.includes(index) ? 2 : 1
                  }}
                >
                  <p className="text-lg text-gray-700 leading-relaxed text-center text-justify">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
